"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastReducer = void 0;
var lodash_1 = require("../utils/lodash");
var toaster_actions_1 = require("../actions/toaster_actions");
var initialState = {
    text: '',
    type: '',
    time: 5000,
};
var ToastReducer = function (state, _a) {
    if (state === void 0) { state = initialState; }
    var type = _a.type, payload = _a.payload;
    switch (type) {
        case toaster_actions_1.TOASTER_ACTIONS.SHOW_TOAST:
            return lodash_1.default.extend({}, state, __assign({}, payload));
        case toaster_actions_1.TOASTER_ACTIONS.HIDE_TOAST:
            return lodash_1.default.extend({}, state, initialState);
        default: {
            return state;
        }
    }
};
exports.ToastReducer = ToastReducer;
